import styled from 'styled-components';

import CheckmarkIconSvg from '../../assets/icons/icon-checkmark.svg?react';

type CheckboxIndicatorVariant = 'emphasis' | 'primary';

type CheckboxIndicatorProps = {
  checked: boolean;
  className?: string;
  variant?: CheckboxIndicatorVariant;
};

const Indicator = styled.span<{
  $checked: boolean;
  $variant: CheckboxIndicatorVariant;
}>`
  width: ${({ theme }) => theme.scale.px(17)};
  height: ${({ theme }) => theme.scale.px(17)};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.scale.px(3)};
  border: ${({ $checked, theme }) =>
    $checked
      ? '0'
      : `${theme.scale.px(2)} solid ${theme.colors.brand.emphasis}`};
  background: ${({ $checked, $variant, theme }) => {
    if (!$checked) {
      return 'transparent';
    }

    return $variant === 'primary'
      ? theme.colors.brand.primary
      : theme.colors.brand.emphasis;
  }};
  display: grid;
  place-content: center;
  flex: 0 0 auto;
`;

const CheckIcon = styled(CheckmarkIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(10)};
  height: ${({ theme }) => theme.scale.px(7)};
  display: block;
  color: ${({ theme }) => theme.colors.text.primary};

  & path {
    stroke: currentColor;
  }
`;

export function CheckboxIndicator({
  checked,
  className,
  variant = 'emphasis',
}: CheckboxIndicatorProps) {
  return (
    <Indicator className={className} $checked={checked} $variant={variant}>
      {checked ? <CheckIcon /> : null}
    </Indicator>
  );
}
